import { render, staticRenderFns } from "./goodsPay.vue?vue&type=template&id=7e25da63&"
import script from "./goodsPay.vue?vue&type=script&lang=js&"
export * from "./goodsPay.vue?vue&type=script&lang=js&"
import style0 from "./goodsPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports